import { render, staticRenderFns } from "./CustomReportsSettings.vue?vue&type=template&id=2f0d9f17&"
import script from "./CustomReportsSettings.vue?vue&type=script&lang=js&"
export * from "./CustomReportsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports